import { useMemo } from 'react';
import { usePrefillsContext } from '../context/prefills.js';
import { useQuoteContext } from '../context/quote.js';
import useExchangeBalance from './use-exchange-balance.js';
import useFromAsset from './use-from-asset.js';
import useFromWalletAccount from './use-from-wallet-account.js';
import useSlippage from './use-slippage.js';
import useSwapMode from './use-swap-mode.js';
import useExchangeFee from './use-exchange-fee.js';
import usePrefilledAmountId from './use-prefilled-amount-id.js';
const getAmountMinusSlippageEquivalent = ({ amount, slippage, }) => amount.mul(1 - slippage / 100);
const useExchangeBalanceMinusFee = () => {
    const [fromAsset] = useFromAsset();
    const [fromWalletAccount] = useFromWalletAccount();
    const [slippage] = useSlippage();
    const [swapMode] = useSwapMode();
    const [prefilledAmountId] = usePrefilledAmountId();
    const { value: prefilledAmounts, isPrefillExchangeable } = usePrefillsContext();
    const balance = useExchangeBalance({
        assetName: fromAsset.name,
        walletAccount: fromWalletAccount.toString(),
    });
    const { value: quote } = useQuoteContext();
    const fee = useExchangeFee({ quote });
    return useMemo(() => {
        if (prefilledAmountId === 'max') {
            const max = prefilledAmounts?.max.value;
            return isPrefillExchangeable && max?.isPositive ? max : balance;
        }
        const balanceMinusFee = fromAsset.name === fromAsset.feeAsset.name ? balance.sub(fee).clampLowerZero() : balance;
        return swapMode === 'ExactIn'
            ? balanceMinusFee.isPositive
                ? balanceMinusFee
                : balance
            : getAmountMinusSlippageEquivalent({ amount: balanceMinusFee, slippage });
    }, [
        prefilledAmountId,
        fromAsset,
        balance,
        fee,
        swapMode,
        slippage,
        prefilledAmounts,
        isPrefillExchangeable,
    ]);
};
export default useExchangeBalanceMinusFee;
